/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum NewsFeedTargetChannel {
    Cockpit = 'Cockpit',
    Stella = 'Stella'
  }

    export const NewsFeedTargetChannelTranslocoMap: Record<NewsFeedTargetChannel, string> = {
    [NewsFeedTargetChannel.Cockpit]: 'newsFeedTargetChannel.cockpit',
    [NewsFeedTargetChannel.Stella]: 'newsFeedTargetChannel.stella',
    };

    export const NewsFeedTargetChannelOptions = [
  { value: NewsFeedTargetChannel.Cockpit, labelKey: 'newsFeedTargetChannel.cockpit' },
  { value: NewsFeedTargetChannel.Stella, labelKey: 'newsFeedTargetChannel.stella' },
    ];

